export function checkDocument(
  doc?: string | unknown
): "cpf" | "cnpj" | "invalid" {
  if (!doc || !["string", "number"].includes(typeof doc)) return "invalid";

  // Clean up the input, removing any non-numeric characters
  const cleanedDoc =
    typeof doc === "string" ? doc.replace(/[^\d]/g, "") : doc.toString();

  if (cleanedDoc.length === 11) {
    return "cpf";
  } else if (cleanedDoc.length === 14) {
    return "cnpj";
  } else {
    return "invalid";
  }
}
